export interface User {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  preschool?: string;
  organizationId: string;
  preschoolIds: string[];
  username?: string;
}

export enum UserRole {
  TEACHER = "Myran.Teacher",
  ADMIN = "Myran.Admin",
  SUPERADMIN = "Myran.SuperAdmin",
  PRINCIPAL = "Myran.Principal",
  PEDAGOGUE = "Myran.Pedagogue",
}

export const UserRoleToLabelMapping: Record<UserRole, string> = {
  [UserRole.SUPERADMIN]: "Superadmin",
  [UserRole.ADMIN]: "Admin",
  [UserRole.TEACHER]: "Lärare",
  [UserRole.PRINCIPAL]: "Rektor",
  [UserRole.PEDAGOGUE]: "SpecialPedagog",
};
export const UserRoleToLabelMappingen: Record<UserRole, string> = {
  [UserRole.SUPERADMIN]: "Super admin",
  [UserRole.ADMIN]: "Admin",
  [UserRole.TEACHER]: "Teacher",
  [UserRole.PRINCIPAL]: "Principal",
  [UserRole.PEDAGOGUE]: "Special Pedagogue",
};

export const UserRoleToLabelMappingDe: Record<UserRole, string> = {
  [UserRole.SUPERADMIN]: "Superadministrator",
  [UserRole.ADMIN]: "Administrator",
  [UserRole.TEACHER]: "Lehrer",
  [UserRole.PRINCIPAL]: "Schulleiter",
  [UserRole.PEDAGOGUE]: "Sonderpädagog*in",
};

export interface ViewUserShape {
  organizationId: string;
  preschoolId?: string;
  name: string;
  role: UserRole;
  email: string;
  phoneNumber: string;
  newPassword: string;
  confirmPassword: string;
  preschoolIds?: string[];
  password?: string;
  username?: string;
}

export type CreateUserDTO = Partial<
  Pick<ViewUserShape, "name" | "email" | "password" | "phoneNumber"> & {
    type: string;
  }
>;
export type UpdateUserDTO = Partial<ViewUserShape>;
export type InviteUserDTO = Pick<ViewUserShape, "organizationId" | "preschoolId" | "role" | "email">;

export interface ResetPasswordShape {
  newPassword: string;
  confirmPassword: string;
}
